import { getTenantRoles,getTenantUserSubscriptionConfig } from "../../../services/tenantUserService";

const schema = async (data) => {
  let s = {
    type: "object",
    properties: {
      tenantName: {
        type: "string",
      },
      tenantUserRoleId: {
        type: "string",
        format: "uuid",
      },
    },
    required: ["tenantName", "tenantUserRoleId"],
  };

  const roles_response = await getTenantRoles(data.tenantId);

  const res = await getTenantUserSubscriptionConfig(data.tenantId);

  if (res.data.value) {
    s = {...s,
      properties: {
        ...s.properties,
        expiresAt: {
          type: ["string", "null"]
        }
      }};
  }

  s.properties.tenantUserRoleId.oneOf = roles_response.data.map((r) => ({
    const: r.id,
    title: r.name,
  }));

  return s;
};

export default schema;
